import { Component, ViewChild } from '@angular/core';
import { ViewController, ItemSliding, Item, AlertController, Searchbar, Config, Content, NavController, ActionSheetController,} from 'ionic-angular';

import { UserMyRadiant as User, AprovalProvider } from '../../../../providers';
import { Nav, NavParams, MenuController, Events, ModalController  } from 'ionic-angular';

import { RepositoryMyRadiant, HelperMyRadiant, ApiMyRadiant} from '../../../../providers';
import { CalendarResult } from 'ion2-calendar';
import { PhotoViewer } from '@ionic-native/photo-viewer';
import { File } from '@ionic-native/file';
import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer';
import { Utility } from '../../../../providers/resources/utility';
import { AndroidPermissions } from '@ionic-native/android-permissions';
import { Geolocation } from '@ionic-native/geolocation';
import { TabsPage } from '../..';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { FileChooser } from '@ionic-native/file-chooser';
import { Base64 } from '@ionic-native/base64';
import { FilePath } from '@ionic-native/file-path';

@Component({
  selector: 'aproval-detail',
  templateUrl: 'page.html'
})
export class AprovalDetail {
  @ViewChild(Content) content: Content;
  
  loading : any;
  segmentActive: string = "general";
  stateRequest = 6;

  parameter = {
    id : null,
    user_code : this.userApi.data.NIK,
    nik: this.userApi.data.NIK,
    token:1,
    user_nik:"",
    id_request:null,
  };
  
  
  data = {
    general:{},
    family:[],
    employee_req:{},
    family_req:[],
    religion:[],
    relationship:[],
    medical:[],
    insurance:[],
    certificate:[],
    preview_img:"./assets/img/no_img.jpg",
  };
  
  different = {
    general:{
      foto:"",
      name:"",
      ttl:"",
      religion:"",
      address:"",
      postalcode:"",
      city:"",
    }
  };
  
  params_new_data = {
    general:{},
    family:[],
    medical:[],
    insurance:[],
    certificate:[],
  };
  
  constructor(
    public navCtrl            : NavController,
    public userApi            : User,
    public menuCtrl           : MenuController,
    public modalCtrl          : ModalController,
    public nav                : Nav,
    public navParams          : NavParams,
    public repositoryProvider : RepositoryMyRadiant,
    public helper             : HelperMyRadiant,
    public viewCtrl           : ViewController,
    public events             : Events,
    public config             : Config,
    public actionSheetCtrl    : ActionSheetController,
    public camera             : Camera,
    public file               : File, 
    private fileChooser       : FileChooser,
    private base64            : Base64,
    private filepath          : FilePath,
    private aprovalProvider   : AprovalProvider,
    private utility           : Utility
  ) {
    this.config.set('backButtonText','Approval Detail'); 
    this.parameter.id_request = this.navParams.get('request_id');
    this.parameter.id = this.navParams.get('employee_id');
    this.loading = this.helper.showLoading("Please Wait..");
    this.getGeneral();
    this.getFamilyRequest();
    this.getGeneralRequest();
    this.getMedical();
    this.getInsurance();
    this.getCeritificate();
  }

  expandSegment(evt,segment): void {
    this.segmentActive = segment;
  }
  collapseSegment(evt,segment){
    this.segmentActive = 'none';
  }
  
  setFile(url){
    let me = this;
    this.filepath.resolveNativePath(url).then(imageData => {
      me.data.preview_img = imageData;
      this.file.resolveLocalFilesystemUrl(imageData).then(file => {
        me.data.general['foto'] = file.name;
      })
      this.base64.encodeFile(imageData).then((base64File: string) => {
        me.data.general['foto_binary'] = base64File;
      }, (err) => {
        console.log(err);
      });
    })
    .catch(err => console.log(err));
  }

  showCamera(){
    let me = this;
    const options: CameraOptions = {
      quality: 25,
      destinationType: this.camera.DestinationType.FILE_URI,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      saveToPhotoAlbum:true,
      sourceType: this.camera.PictureSourceType.CAMERA,
      cameraDirection:this.camera.Direction.FRONT
    }
    
    this.camera.getPicture(options).then((uri) => {
      this.setFile(uri);
      
    }, (err) => {
     // Handle error
    });
  }

  chooseFile(){
    let me = this;
    this.fileChooser.open()
      .then(uri => {
        this.setFile(uri);
      })
      .catch(e => console.log(e));
  }

  changeFoto(){
    let actionSheet = this.actionSheetCtrl.create({
      title: 'Change Photo',
      buttons: [
        {
          text: 'Use Camera',
          // role: 'destructive',
          handler: () => {
            this.showCamera();
          }
        },
        {
          text: 'Upload Photo',
          handler: () => {
            this.chooseFile();
          }
        },
        {
          text: 'Cancel',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
 
    actionSheet.present();
  }

  togleSegment(content,active){
    if(content == active){
      this.collapseSegment(null,content);
    }else{
      this.expandSegment(null,content);
    }
  }

  // getReligion(){
  //   let me = this;
  //   this.loading = this.helper.showLoading("Please Wait..");
  //   this.repositoryProvider.getProfilTicket(this.parameter).subscribe((resp:any) => {
  //     this.stateRequest = this.stateRequest - 1;
  //     if(this.stateRequest == 0){
  //       try {
  //         this.loading.dismiss();
  //       } catch (error) {
          
  //       }
  //     }
  //     if(resp.success){
  //       resp.data.forEach(row => {
          
  //       });
  //     }
  //   },(err) => {
  //     this.helper.presentToast('Error');
  //     try {
  //       this.loading.dismiss();
  //     } catch (error) {
        
  //     }
  //   }); 
  // }

  getGeneral(){
    let me = this;
    this.repositoryProvider.getProfilGeneral(this.parameter).subscribe((resp:any) => {
    this.stateRequest = this.stateRequest - 1;
    if (this.stateRequest == 0) {
      try {
        this.loading.dismiss();
      } catch (error) {
      }
    }
      if(resp.success){
       resp.data.idnumber  = resp.data.code;
       resp.data.jabatan   = resp.data.Jabatan;
       resp.data.division  = resp.data.division_name;
       resp.data.address_real = resp.data.address;
       resp.data.address = resp.data.address + ' '+resp.data.city + ' '+resp.data.postal_code;
        me.data.general = resp.data;
        if (this.stateRequest == 0) {
          this.checking_different();
        }
      }
    },(err) => {
      this.helper.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }

  getFamilyRequest(){
    let me = this;
    this.aprovalProvider.getRequestFamily(this.parameter).subscribe((resp:any) => {
      this.stateRequest = this.stateRequest - 1;
      if(this.stateRequest == 0){
        try {
          this.loading.dismiss();
        } catch (error) {
          
        }
      }
      if(resp.success){
        me.data.family = resp.data;
        this.params_new_data.family = resp.data;
        if (this.stateRequest == 0) {
          this.checking_different();
        }
      }
    },(err) => {
      this.helper.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }

  getGeneralRequest(){
    let me = this;
    this.aprovalProvider.getRequestGeneral(this.parameter).subscribe((resp:any) => {
    this.stateRequest = this.stateRequest - 1;
    if (this.stateRequest == 0) {
      try {
        this.loading.dismiss();
      } catch (error) {
      }
    }
      if(resp.success){
        resp.data.address_real = resp.data.address;
        resp.data.address = resp.data.address + ' '+resp.data.city + ' '+resp.data.postal_code;
        me.data.employee_req = resp.data;
        if (this.stateRequest == 0) {
          this.checking_different();
        }
      }
    },(err) => {
      this.helper.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }

  approve(){
    let me = this;
    let optionsSwal = {
      title:"Approve Changes ?",
      icon:"",
      dangerMode:false,
      btnCancel:"Cancel",
      btnConfirm:"Approve",
    }
   this.helper.presentSwalConfirmation(optionsSwal,
    (note) => {
      let params = {
        general : JSON.stringify(me.params_new_data.general),
        family : JSON.stringify(me.params_new_data.family),
        medical : JSON.stringify(me.params_new_data.medical),
        insurance : JSON.stringify(me.params_new_data.insurance),
        certificate : JSON.stringify(me.params_new_data.certificate),
        id_request : me.data.employee_req['id']
      };
      me.aprovalProvider.approvalAction(params).subscribe((resp:any) => {
        try {
          this.loading.dismiss();
        } catch (error) {
        }
        if (resp.success) {
          me.viewCtrl.dismiss();
          this.events.publish('aproval:reload');
          
          me.helper.presentToast("Success Approved");
        }
      },(err) => {
        this.helper.presentToast('Error');
        try {
          this.loading.dismiss();
        } catch (error) {
          
        }
      });
    },(err) => {
      try {
        me.loading.dismiss();
      } catch (error) {
        
      }
    });
  }

  rejected(){
    let me = this;
    let optionsSwal = {
      title:"Reject Changes ?",
      icon:"",
      dangerMode:false,
      btnCancel:"Cancel",
      btnConfirm:"Reject",
      inputPlaceholder:"Notes...",
      inputType:"textarea",
    }
    this.helper.presentSwalConfirmation(optionsSwal,
      (note) => {
        let params = {
          request_id : me.data.employee_req['id'],
          note : note,
          employee_id : me.data.employee_req['hrm_employee_id']
        };
        me.loading = this.helper.showLoading("Process...");
        me.aprovalProvider.rejectAction(params).subscribe((resp:any) => {
          try {
            this.loading.dismiss();
          } catch (error) {
          }
          if (resp.success) {
            me.viewCtrl.dismiss();
            this.events.publish('aproval:reload');
            me.helper.presentToast("Success Rejected");
          }
        },(err) => {
          this.helper.presentToast('Error');
          try {
            this.loading.dismiss();
          } catch (error) {
            
          }
        });
      },
      (err) => {
        try {
          me.loading.dismiss();
        } catch (error) {
          
        }
      },true);
  
  }

  clean_state(){
    this.different.general.foto = "";
    this.different.general.name = "";
    this.different.general.ttl = "";
    this.different.general.religion = "";
    this.different.general.address = "";
    this.different.general.postalcode = "";
    this.different.general.city = "";
  }

  checking_different(){
    this.clean_state();

    let old_general = this.data.general;
    let new_general = this.data.employee_req; 
    this.params_new_data.general['id'] = old_general['id'];

    // if (old_general['foto'] != null && old_general['foto']!=undefined) {
    //   this.data.preview_img = old_general['foto'];
    // }
    if (new_general['foto'] != old_general['foto']) {
      this.different.general.foto = "different";
      this.params_new_data.general['foto'] = new_general['foto'];
    }
    this.data.employee_req['foto'] = this.utility.getFolderUpload_server() + this.data.employee_req['foto'];
    this.data.general['foto'] = this.utility.getFolderUpload_server() + this.data.general['foto'];

    if (old_general['name'] != new_general['name']) {
      this.different.general.name = "different";
      this.params_new_data.general['name'] = new_general['name'];
    }
    if (old_general['ttl'] != new_general['ttl']) {
      this.different.general.ttl = "different";
      this.params_new_data.general['place_of_birth'] = new_general['place_birth'];
      this.params_new_data.general['date_of_birth'] = new_general['date_of_birth'];
    }
    if (old_general['hrm_religion_id'] != new_general['hrm_religion_id']) {
      this.different.general.religion = "different";
      // this.params_new_data.general['religion'] = new_general['religion'];
      this.params_new_data.general['hrm_religion_id'] = new_general['hrm_religion_id'];
    }

    if (old_general['address_real'] != new_general['address_real']) {
      this.different.general.address = "different";
      this.params_new_data.general['address'] = new_general['address_real'];
    }
    if (old_general['postal_code'] != new_general['postal_code']) {
      this.different.general.address = "different";
      this.params_new_data.general['postal_code'] = new_general['postal_code'];
    }
    if (old_general['city'] != new_general['city']) {
      this.different.general.address = "different";
      this.params_new_data.general['city'] = new_general['hrm_city_id'];
      // this.params_new_data.general['hrm_city_id'] = new_general['hrm_city_id'];
    }

  }
  getMedical(){
    let me = this;
    this.aprovalProvider.getRequestEditMedical(this.parameter).subscribe((resp:any) => {
      this.stateRequest = this.stateRequest - 1;
      if(this.stateRequest == 0){
        try {
          this.loading.dismiss();
        } catch (error) {
          
        }
      }
      if(resp.success){
        me.data.medical = resp.data;
        this.params_new_data.medical = resp.data;
        if (this.stateRequest == 0) {
          this.checking_different();
        }
      }
    },(err) => {
      this.helper.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }

  getInsurance(){
    let me = this;
    this.aprovalProvider.getRequestEditInsurance(this.parameter).subscribe((resp:any) => {
      this.stateRequest = this.stateRequest - 1;
      if(this.stateRequest == 0){
        try {
          this.loading.dismiss();
        } catch (error) {
          
        }
      }
      if(resp.success){
        me.data.insurance = resp.data;
        this.params_new_data.insurance = resp.data;
        if (this.stateRequest == 0) {
          this.checking_different();
        }
      }
    },(err) => {
      this.helper.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }

  getCeritificate(){
    let me = this;
    this.aprovalProvider.getRequestEditCeritificate(this.parameter).subscribe((resp:any) => {
      this.stateRequest = this.stateRequest - 1;
      if(this.stateRequest == 0){
        try {
          this.loading.dismiss();
        } catch (error) {
          
        }
      }
      if(resp.success){
        me.data.certificate = resp.data;
        this.params_new_data.certificate = resp.data;
        if (this.stateRequest == 0) {
          this.checking_different();
        }
      }
    },(err) => {
      this.helper.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }

}



// WEBPACK FOOTER //
// ./src/pages/dashboard/aproval/aproval_detail/page.ts